import { Component, DOCUMENT, HostBinding, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CrmConfig } from '@frontend/sports/common/client-config-data-access';
import { RotatingTeaserPayload } from '@frontend/sports/types/components/widget/types';
import { WidgetComponent } from '@frontend/sports/widget/core/feature';
import { tap } from 'rxjs';

import { Promotion } from '../crm-offer-data/crm-offer.model';
import { CrmPromotionProviderService } from '../crm-promotion/crm-promotion-provider.service';
import { preloadPromotionImage } from './teaser-image-preloader';
import { TeaserComponent } from './teaser.component';
import { EnhancedTeaserViewModel } from './teaser.models';
import { TeasersService } from './teasers.service';

@Component({
    selector: 'ms-rotating-teaser-widget',
    templateUrl: './rotating-teaser-widget.component.html',
    imports: [TeaserComponent],
})
export class RotatingTeaserWidgetComponent extends WidgetComponent<RotatingTeaserPayload> {
    private teaserService = inject(TeasersService);
    private crmConfig = inject(CrmConfig);

    @HostBinding('class') className = 'rotating-teaser-widget';

    teasers: EnhancedTeaserViewModel[];
    teasersEnhancing = false;
    promotions: Promotion[];

    private readonly _doc = inject(DOCUMENT);

    constructor() {
        const promoService = inject(CrmPromotionProviderService);

        super();
        promoService.promotions$.pipe(tap(this.setPromotions), takeUntilDestroyed(this.destroyRef)).subscribe(this.setHasData);
    }

    override onData({ teasers }: RotatingTeaserPayload): void {
        if (teasers?.length > 0 && this.hidden) {
            // pre-emptively display the template to let the ms-teaser component reserve the space
            // it will anyway reserve after the teasers are enhanced
            this.teasersEnhancing = true;
            this.setHasData();
        }
        this.teaserService.enhance(teasers).subscribe((processed) => {
            this.teasers = processed;
            this.teasersEnhancing = false;
            this.setHasData();
        });
    }

    private setPromotions = (list: Promotion[]) => {
        this.promotions = list.filter((promo) => promo.noFilters && promo.banner).slice(0, this.crmConfig.promotions.bannerCount.lobby);
        preloadPromotionImage(this.promotions[0], this._doc);
    };

    private setHasData = () => {
        this.hasData = this.teasersEnhancing || !!this.teasers?.length || !!this.promotions?.length;
        this.setWidgetLoaded();
    };
}
